import { FunctionComponent, useContext, useState } from "react";
import styles from "./DashboardSideBar.module.css";
import images from "../../../assets/images/index";
import { useLocation, useNavigate } from "react-router-dom";
import { globalContext } from "../../../Provider/AppProvider";
import { CustomPaperComponent, roles } from "../../../helper";
import { Dialog, Menu } from "@mui/material";
import ProfileDropdown from "../dropdown/profile-dropdown/ProfileDropdown";
import PopupComponent from "../success-popup/PopupComponent";
import ChangePassword from "../change-password/ChangePassword";

interface SidebarProps {
  path: string;
  onclick: () => void;
  label: string;
  icon: string;
  alt: string;
}

interface Dashboardprops {
  showSidebar?: boolean;
}
const DashboardSideBar: FunctionComponent<Dashboardprops> = ({
  showSidebar,
}) => {
  const {
    sidebarQuickAsystLogo,
    dahsboardIcon,
    sidebarTicketIcon,
    sidebarUserIcon,
    AffiliateIcon,
    QuickAsystIcon,
    errordashboard,
    settings,
    DefaultProfile
  } = images;
  const navigate = useNavigate();
  const location = useLocation();
  const {globalState} = useContext<any>(globalContext)
  const [anchorEl, setAnchorEl] = useState(null);
  const [openSuccessDialog, setOpenSuccessDialog] = useState<boolean>(false);
  const [openDialog, setOpenDialog] = useState(false);
  const baseURL = process.env.REACT_APP_FRONTEND_URL;
  const StyledComponent = CustomPaperComponent();

  const openProfileMenu = Boolean(anchorEl);

  const handleProfileClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCloseDialogPop = () => {
    setOpenSuccessDialog(false);
    navigate("/login");
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const routes: SidebarProps[] = [];
  if (globalState.profile.userRole === roles.ADMIN ) {
    routes.push(
    {
      path: "dashboard",
      onclick: () => navigate("/dashboard"),
      label: "Dashboard",
      icon: dahsboardIcon,
      alt: "DashboardIcon",
    },
    {
      path: "tickets",
      onclick: () => navigate("/tickets"),
      label: "Tickets",
      icon: sidebarTicketIcon,
      alt: "TicketsIcon",
    },
    {
      path: "users",
      onclick: () => navigate("/users"),
      label: "Users",
      icon: sidebarUserIcon,
      alt: "UsersIcon",
    },
    {
      path: "affiliate",
      onclick: () => navigate("/affiliate"),
      label: "Affiliates",
      icon: AffiliateIcon,
      alt: "AffiliateIcon",
    },
    {
      path: "settings",
      onclick: () => navigate("/settings"),
      label: "Settings",
      icon: settings,
      alt: "settingsIcon",
    },
    {
      path: "logs",
      onclick: () => navigate("/logs"),
      label: "Mail Parser Logs",
      icon: errordashboard,
      alt: "errorIcon",
    },
    {
      path:"auditLogs",
      onclick: () => navigate("/auditLogs"),
      label:"Audit Logs",
      icon: errordashboard,
      alt:"auditLogsIcon",
    }
  )
}else if(globalState.profile.userRole === roles.AFFILIATER_ADMIN ) {
    routes.push(
    {
      path: "dashboard",
      onclick: () => navigate("/dashboard"),
      label: "Dashboard",
      icon: dahsboardIcon,
      alt: "DashboardIcon",
    },
    {
      path: "tickets",
      onclick: () => navigate("/tickets"),
      label: "Tickets",
      icon: sidebarTicketIcon,
      alt: "TicketsIcon",
    },
    {
      path: "users",
      onclick: () => navigate("/users"),
      label: "Users",
      icon: sidebarUserIcon,
      alt: "UsersIcon",
    },
    {
      path: "affiliate",
      onclick: () => navigate("/affiliate"),
      label: "Affiliates",
      icon: AffiliateIcon,
      alt: "AffiliateIcon",
    },
    {
      path: "settings",
      onclick: () => navigate("/settings"),
      label: "Settings",
      icon: settings,
      alt: "settingsIcon",
    },
    {
      path: "logs",
      onclick: () => navigate("/logs"),
      label: "Mail Parser Logs",
      icon: errordashboard,
      alt: "errorIcon",
    }
  )
}
else if(globalState.profile.userRole === "logitix_user"){
  routes.push(
    {
      path: "tickets",
      onclick: () => navigate("/tickets"),
      label: "Tickets",
      icon: sidebarTicketIcon,
      alt: "TicketsIcon",
    },
    {
      path: "settings",
      onclick: () => navigate("/settings"),
      label: "Settings",
      icon: settings,
      alt: "settingsIcon",
    },
    {
      path: "logs",
      onclick: () => navigate("/logs"),
      label: "Logs",
      icon: errordashboard,
      alt: "errorIcon",
    },
  )
}else if(globalState.profile.userRole === "marketing_user" ){
  routes.push(
    {
      path: "users",
      onclick: () => navigate("/users"),
      label: "Users",
      icon: sidebarUserIcon,
      alt: "UsersIcon",
    },
    {
      path: "affiliate",
      onclick: () => navigate("/affiliate"),
      label: "Affiliates",
      icon: AffiliateIcon,
      alt: "AffiliateIcon",
    },
  )
}else if (globalState.profile.userRole === roles.SUPER_USER) {
    routes.push(
    {
      path: "dashboard",
      onclick: () => navigate("/dashboard"),
      label: "Dashboard",
      icon: dahsboardIcon,
      alt: "DashboardIcon",
    },
    // {
    //   path: "tickets",
    //   onclick: () => navigate("/tickets"),
    //   label: "Tickets",
    //   icon: sidebarTicketIcon,
    //   alt: "TicketsIcon",
    // },
    {
      path: "new-list",
      onclick: () => navigate("/new-list"),
      label: "New Tickets",
      icon: sidebarTicketIcon,
      alt: "NewTicketsIcon",
    },
  )
}
  
  const userPhoto = globalState?.profile?.photo;
  const userName = (globalState?.profile?.firstName || "") + " " + (globalState?.profile?.lastName || "");

  return (
    <div
      className={`${styles.dashboardSideBar} ${
        showSidebar ? styles.expanded : styles.collapsed
      }`}
    >
      <div className={`${styles.logo} ${
        showSidebar ? styles.expandedlogo : styles.collapsedlogo
      }`}>
        <img
          className={
            showSidebar? styles.QuickAsystIcon  : styles.QuickAsystIconhide
          }
          alt="sidebarLogo"
          src={showSidebar? sidebarQuickAsystLogo: QuickAsystIcon}
          onClick={() => {
            globalState.profile.userRole===roles.ADMIN || globalState.profile.userRole===roles.AFFILIATER_ADMIN || globalState.profile.userRole === roles.SUPER_USER
             ? navigate("/dashboard"): 
            globalState.profile.userRole==="marketing_user" ? navigate("/users") :
            navigate("/tickets")
          }
          }
          data-testid="sidebarLogo"
        />
      </div>

      <div className={styles.menuContainer}>
        {routes.map((route: SidebarProps, index: number) => (
          <div
            className={
              location.pathname.slice(1) === route.path || location.pathname.slice(1).includes(route.path)
                ? styles.dashboardActive
                : styles.dashboardInactive
            }
            onClick={route.onclick}
            key={`sidebar-${index}`}
          >
            <img
              className={styles.roundedOutlineDashboard}
              alt={route.alt}
              src={route.icon}
            />
            {showSidebar && <div className={styles.dashboard1}>{route.label}</div>}
          </div>
        ))}
      </div>

      {(location.pathname === "/new-list" || (globalState.profile.userRole === roles.SUPER_USER && location.pathname === "/dashboard")) && (
        <div 
          className={showSidebar ? styles.profileSection : styles.profileSectionCollapsed}
          onClick={handleProfileClick}
        >
          <div className={styles.profileOuterCircle}>
            <img 
              className={styles.imgIcon} 
              alt="userProfile" 
              src={userPhoto ? (baseURL + userPhoto) : DefaultProfile} 
            />
          </div>
          {showSidebar && (
            <div className={styles.userName}>
              {userName.trim() || "User"}
            </div>
          )}
        </div>
      )}

      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={openProfileMenu}
        onClose={handleClose}
        transformOrigin={{ horizontal: "left", vertical: "bottom" }}
        anchorOrigin={{ horizontal: "right", vertical: "top" }}
        MenuListProps={{
          disablePadding: true,
        }}
        classes={{ paper: styles.customMenu }}
      >
        <ProfileDropdown 
          handleClose={handleClose} 
          setOpenSuccessDialog={setOpenSuccessDialog} 
          setOpenDialog={setOpenDialog}
        />
      </Menu>

      <Dialog
        open={openSuccessDialog}
        onClose={handleCloseDialogPop}
        PaperComponent={StyledComponent}
      >
        <PopupComponent
          handleClose={handleCloseDialogPop}
          title={"Password Updated"}
          subTitle={
            "Your password has been successfully updated. Please sign in to your account."
          }
        />
      </Dialog>
      <Dialog open={openDialog} classes={{ paper: styles.customDialog }}>
        <ChangePassword handleCloseDialog={handleCloseDialog} setOpenSuccessDialog={setOpenSuccessDialog} />
      </Dialog>
    </div>
  );
};

export default DashboardSideBar;
